import { Component, OnInit } from "@angular/core"
import { FooterService } from "../../services/footer.service"
import { UserService } from "../../services/user.service"
import { EduComponent } from "../../utils/eduComponent"
import Utils from "../../utils/utils"
import { ModalService } from "../modal/modal.service"
import { InformationModalComponent } from "../modals/information-modal/information-modal.component"
import { FeedbackModalComponent } from "./feedback-modal/feedback-modal.component"
import { AuthModalComponent } from "../modals/auth-modal/auth-modal.component"
import { Router } from "@angular/router"
import { ResourceService } from "../../services/resource.service"
import { STATIC_IMAGES } from "../../models/constants"
import { AddOnViewService } from "../../services/add-on-view.service"

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
})
export class FooterComponent extends EduComponent implements OnInit {
    feedbackFormHtml = null
    gtmPrefix: string = "gtm-footer-"
    pbsLogoWhite
    currentYear
    isAddonView: boolean
    isEmailValid: boolean = false
    isStudentExperience: boolean = false
    email: any = ""

    constructor(
        private footerService: FooterService,
        private modalService: ModalService,
        public userService: UserService,
        private resourceService: ResourceService,
        public addOnService: AddOnViewService,
        public router: Router
    ) {
        super()
        this.pbsLogoWhite = STATIC_IMAGES.pbs_logo_white
    }

    public ngOnInit() {
        this.currentYear = Utils.getCurrentYear()
        this.isAddonView = this.addOnService.isAddonView
        this.isStudentExperience = Utils.hasStudentExperience()
    }

    public teacherLogin() {
        if (window.location.pathname === "/student/") {
            this.router.navigate(["/"])
        } else {
            this.resourceService.switchResourceView()
        }
        this.modalService.open(AuthModalComponent)
    }

    public changeUserExperience(studentState: boolean, target?: string) {
        this.userService.switchUserExperience(studentState, target)
    }
    public openFeedbackForm(event) {
        event.preventDefault()
        this.modalService.open(FeedbackModalComponent, { size: "lg" })
    }

    validateEmail() {
        this.email = (document.getElementById("email-eloqua-newsletter") as HTMLInputElement).value
        this.isEmailValid = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.email)
    }

    public subscribe() {
        const settings = (window as any).PBSLM.eloqua.footer
        const subscribeBtn = document.getElementById("eloqua-newsletter-go")
        this.addSub(
            this.footerService
                .subscribeToNewsletter(
                    settings.url,
                    settings.elqFormName,
                    settings.elqSiteId,
                    this.email
                )
                .subscribe(
                    (response) => {
                        subscribeBtn.classList.remove("disabled")
                        subscribeBtn.removeAttribute("disabled")
                        this.modalService.open(InformationModalComponent, {
                            data: {
                                message: "You have been subscribed to the newsletter!",
                            },
                        })
                    },
                    (error) => {
                        subscribeBtn.classList.remove("disabled")
                        subscribeBtn.removeAttribute("disabled")
                        this.modalService.open(InformationModalComponent, {
                            data: {
                                message: "Something went wrong. Please try again later.",
                            },
                        })
                    }
                )
        )
    }
}
